import { useSelector } from 'react-redux'
import { nameOfExclusiveUiUserSelector } from '../selectors'

export const useNameOfUserUsingExclusiveUi = () => {
  return useSelector(nameOfExclusiveUiUserSelector)
}
